import classNames from 'classnames'
import { type ChangeEvent, useState } from 'react'

import { EIcons } from '@/app/types/iconType'
import { Icon } from '@/shared'

import style from './CustomField.module.scss'

interface IProps {
    name: string
    value: string
    onChange: (e: ChangeEvent<HTMLInputElement>) => void
    onFocus?: () => void
    onZeroText?: (name: string) => void
    type?: 'text' | 'password'
    className?: string
    placeholder?: string
    disabled?: boolean
    error?: string | null
}

export const InputComponent = (props: IProps) => {
    const { name, className, placeholder, type, value, disabled, onChange, onFocus, onZeroText, error } = props

    const [isFocused, setIsFocused] = useState(false)
    const [txtType, setType] = useState<string>(type || 'text')

    const onSwitchPasswordType = () => {
        if (txtType === 'password') {
            setType('text')
        } else {
            setType('password')
        }
    }

    const onHandleFocus = () => {
        setIsFocused(true)
        if (onFocus) {
            onFocus()
        }
    }
    const onBlur = () => setIsFocused(false)
    const onHandleZeroText = () => {
        if (onZeroText) {
            onZeroText(name)
        }
    }

    const labelStyles = classNames(style.label, isFocused || value ? style.labelFocused : style.labelBlured)

    return (
        <div className={style.container}>
            {!disabled && type !== 'password' && onZeroText && (
                <div className={style.inputAction} onClick={onHandleZeroText}>
                    <Icon iconName={EIcons.CLOS} />
                </div>
            )}
            {!disabled && type === 'password' && (
                <div className={style.inputAction} onClick={onSwitchPasswordType}>
                    <Icon iconName={txtType === 'password' ? EIcons.SEEPSWRD : EIcons.HIDPSWRD} />
                </div>
            )}

            <input
                name={name}
                onFocus={onHandleFocus}
                type={txtType}
                onBlur={onBlur}
                className={classNames(className, style.field)}
                value={value}
                onChange={onChange}
                disabled={disabled}
            />
            <label className={labelStyles}>{placeholder}</label>
            {error && <div className={style.error}>{error}</div>}
        </div>
    )
}
